module.exports = __webpack_public_path__ + "assets/images/preventivo.a4f5543c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/preventivo.png
// module id = 822
// module chunks = 1